import * as ambassadorWixBookingsAvailabilityV2TimeSlot from './bookings-availability-v2-time-slot-event-time-slots.http.js';
import * as ambassadorWixBookingsAvailabilityV2TimeSlotTypes from './bookings-availability-v2-time-slot-event-time-slots.types.js';
import * as ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes from './bookings-availability-v2-time-slot-event-time-slots.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listEventTimeSlots(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.ListEventTimeSlotsRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.ListEventTimeSlotsRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.ListEventTimeSlotsResponse,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.ListEventTimeSlotsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV2TimeSlot.listEventTimeSlots(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/time-slots/event',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEventTimeSlot(): __PublicMethodMetaInfo<
  'GET',
  { eventId: string },
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.GetEventTimeSlotRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.GetEventTimeSlotRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.GetEventTimeSlotResponse,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.GetEventTimeSlotResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV2TimeSlot.getEventTimeSlot(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/time-slots/event/{eventId}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TimeSlot as TimeSlotOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  EventInfo as EventInfoOriginal,
  WaitingList as WaitingListOriginal,
  BookingPolicyViolations as BookingPolicyViolationsOriginal,
  AvailableResources as AvailableResourcesOriginal,
  Resource as ResourceOriginal,
  NestedTimeSlot as NestedTimeSlotOriginal,
  NonBookableReasons as NonBookableReasonsOriginal,
  ListEventTimeSlotsRequest as ListEventTimeSlotsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListEventTimeSlotsResponse as ListEventTimeSlotsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  GetEventTimeSlotRequest as GetEventTimeSlotRequestOriginal,
  GetEventTimeSlotResponse as GetEventTimeSlotResponseOriginal,
  ListAvailabilityTimeSlotsRequest as ListAvailabilityTimeSlotsRequestOriginal,
  CustomerChoices as CustomerChoicesOriginal,
  ResourceType as ResourceTypeOriginal,
  ListAvailabilityTimeSlotsResponse as ListAvailabilityTimeSlotsResponseOriginal,
  GetAvailabilityTimeSlotRequest as GetAvailabilityTimeSlotRequestOriginal,
  GetAvailabilityTimeSlotRequestCustomerChoices as GetAvailabilityTimeSlotRequestCustomerChoicesOriginal,
  GetAvailabilityTimeSlotResponse as GetAvailabilityTimeSlotResponseOriginal,
  ListMultiServiceAvailabilityTimeSlotsRequest as ListMultiServiceAvailabilityTimeSlotsRequestOriginal,
  Service as ServiceOriginal,
  V2CustomerChoices as V2CustomerChoicesOriginal,
  ListMultiServiceAvailabilityTimeSlotsResponse as ListMultiServiceAvailabilityTimeSlotsResponseOriginal,
  GetMultiServiceAvailabilityTimeSlotRequest as GetMultiServiceAvailabilityTimeSlotRequestOriginal,
  GetMultiServiceAvailabilityTimeSlotResponse as GetMultiServiceAvailabilityTimeSlotResponseOriginal,
} from './bookings-availability-v2-time-slot-event-time-slots.types.js';
